import { useState } from "react";
import type { ReactNode } from "react";
import { getTheme, setTheme } from "../theme";
import type { ThemeChoice } from "../theme";

const OPTIONS: { value: ThemeChoice; label: string; icon: ReactNode }[] = [
  {
    value: "system",
    label: "System",
    // Half a disc filled: light and dark at once.
    icon: (
      <>
        <circle cx="12" cy="12" r="8" fill="none" />
        <path d="M12 4a8 8 0 0 1 0 16Z" stroke="none" fill="currentColor" />
      </>
    ),
  },
  {
    value: "light",
    label: "Light",
    icon: (
      <>
        <circle cx="12" cy="12" r="4" fill="none" />
        <path d="M12 2v2.5M12 19.5V22M2 12h2.5M19.5 12H22M4.9 4.9l1.8 1.8M17.3 17.3l1.8 1.8M4.9 19.1l1.8-1.8M17.3 6.7l1.8-1.8" />
      </>
    ),
  },
  {
    value: "dark",
    label: "Dark",
    icon: <path d="M20 14.5A8 8 0 1 1 9.5 4a6.5 6.5 0 0 0 10.5 10.5Z" fill="none" />,
  },
];

/** Light, dark or follow the phone, for this device only; each phone in the house chooses for itself. */
export function AppearanceSection() {
  const [choice, setChoice] = useState(getTheme);

  function choose(next: ThemeChoice) {
    setTheme(next);
    setChoice(next);
  }

  return (
    <section className="section">
      <h2 className="section__title">
        <span className="section__emoji" aria-hidden="true">
          🎨
        </span>
        Appearance
      </h2>
      <div className="segmented appearance" role="radiogroup" aria-label="Appearance">
        {OPTIONS.map((o) => (
          <button
            key={o.value}
            className="segmented__option"
            type="button"
            role="radio"
            aria-checked={choice === o.value}
            onClick={() => choose(o.value)}
          >
            <svg className="appearance__icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
              {o.icon}
            </svg>
            {o.label}
          </button>
        ))}
      </div>
    </section>
  );
}
